import Modal from '@Components/Shared/Modals/Modal';
import { Fragment } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import translator from '@Components/Utilities/Translator';

const GlobalBrandsModal = (props) => {
	return (
		<Modal containerClassName="global-brands-modal" contentClassName="global-brands-modal-content" onEscapeKeyClose={props.onClose} isGlobalBrandsModal>
			<Modal.Header headerClassName='global-brands-modal-header' onClose={props.onClose}>
				<Modal.Title>
					{props.regionInfo[0].RegionName} 
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p id='description-label' className='hidden'>Browse brands in {props.regionInfo[0].RegionName}{(props.regionInfo.length == 2 ? " and " + props.regionInfo[1].RegionName : "")}</p>
				{props.regionInfo.map((region, index) => 
					<Fragment key={index}>
						{index > 0 &&
							<Modal.Title headingClassName="additional-region-divider">
								{region.RegionName}
							</Modal.Title>}
						{region.RegionCountries && region.RegionCountries.length > 0 && region.RegionCountries.map((country, index) =>
							<Fragment key={index}>
								{region.RegionCountries.length == 1 ?
									<div className="brand-container">
										{country.CountryBrands.map((brand, index) =>
											<a className="brand-box" href={brand.BrandUrl} target="_blank" key={index}>
												<img src={brand.BrandLogoUrl} alt={brand.BrandName} aria-hidden={true} />
												{brand.BrandName}
												<span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
											</a>
										)}
									</div>
									:
									<Accordion disableGutters>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls={`panel-${country.CountryName}-brands-content`}
											className="accordion-header country-header"
										>
											<img src={country.CountryFlagUrl} className="flag" alt={country.CountryName} aria-hidden={true} />
											<strong>{country.CountryName}</strong>
										</AccordionSummary>
										<AccordionDetails>
											<div className="brand-container">
												{country.CountryBrands.map((brand, index) =>
													<a className="brand-box" href={brand.BrandUrl} target="_blank" key={index}>
														<img src={brand.BrandLogoUrl} alt={brand.BrandName} aria-hidden={true} />
														{brand.BrandName}
														<span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
													</a>)}
											</div>
										</AccordionDetails>
									</Accordion>}
							</Fragment>
						)}
					</Fragment>
				)}
			</Modal.Body> 
        </Modal>
    );
};

export default GlobalBrandsModal;
global.GlobalBrandsModal = GlobalBrandsModal;